export default __webpack_public_path__ + "static/media/BPI_PERSONAL.037de054.svg";